export default [
  {
    path: '/ebooks',
    name: 'Ebooks',
    component: () => import(/* webpackChunkName: "ebooks" */ '@/views/Ebooks/pages')
  },
  {
    path: '/list-ebooks-categories',
    name: 'ListEbooksCategories',
    component: () => import(/* webpackChunkName: "ebooks" */ '@/views/Ebooks/pages/ListCategories')
  },
  {
    path: '/register-ebooks',
    name: 'RegisterEbooks',
    component: () => import(/* webpackChunkName: "ebooks" */ '@/views/Ebooks/pages/RegisterEbooks')
  },
  {
    path: '/list-ebooks',
    name: 'ListEbooks',
    component: () => import(/* webpackChunkName: "ebooks" */ '@/views/Ebooks/pages/ListEbooks')
  },
]
